import { useCallback, useState } from 'react';
import JSZip from 'jszip';

const useDownloadPdf = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadMultiple = useCallback(async pdfObjects => {
    setIsDownloading(true);
    const zip = new JSZip();
    const promises = pdfObjects.map(({ signed_doc_url, form_name }) =>
      fetch(signed_doc_url)
        .then(async response => {
          const blob = await response.blob();
          zip.file(
            `${signed_doc_url.substring(
              signed_doc_url.lastIndexOf('/') + 1,
              signed_doc_url.lastIndexOf('.'),
            )}.pdf`,
            blob,
          );
        })
        .catch(error => {
          console.error(`Error downloading PDF file ${form_name}:`, error);
        }),
    );

    try {
      await Promise.all(promises);
      const content = await zip.generateAsync({ type: 'blob' });
      const url = window.URL.createObjectURL(content);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'pdfs.zip';
      a.click();
    } catch (error) {
      console.error('Error generating the ZIP file:', error);
    }

    setIsDownloading(false);
  }, []);

  return { downloadMultiple, isDownloading };
};

export default useDownloadPdf;
